export default "__VITE_ASSET__0ef4d75a__"